<template>
  <div class="w-full h-full relative">

    <O3D :sx="1.0" :sy="1.0" :sz="1.0">
      <O3D>
        <IsoCityLights v-if="renderer && camera && ready"></IsoCityLights>
      </O3D>
      <!-- <O3D :sx="1 / 3" :sy="1 / 3" :sz="1 / 3" :ry="pi">
        <IsoCityBlock @click="onClickItem($event)" :py="119"></IsoCityBlock>
      </O3D> -->
      <Floor :py="-100" :scale="{ x: 100, y: 100, z: 100 }"></Floor>
      <IsoCityGrid></IsoCityGrid>

      <!-- <O3D> -->
        <!-- <Game ref="game"></Game> -->
      <!-- </O3D> -->
    </O3D>
    <!-- <IsoCityGrid></IsoCityGrid> -->

    <!-- </O3D> -->
  </div>
</template>

<script>
import { getID } from '../Reusable/O3DG2'
import { RenderRoot } from '../Reusable/RenderRoot'
import { PCamera } from '../Reusable/PCamera'
import { loadTexture } from '../Reusable/loadTexture'
import { RayPlay } from '../Reusable/RayPlay'
// import { CubeCam } from '../Reusable/CubeCam'
import { CityControls } from '../CanvasLayout/City/CityControls.js'
// import { CityBloom } from '../CanvasLayout/City/CityBloom.js'
import { Scene } from 'three'
import { MeshMatcapMaterial } from 'three'
// import { ShaderCubeChromatics } from '../Reusable/ShaderCubeChromatics'
// import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js'

export default {
  mixins: [RenderRoot],
  components: {
  },
  data () {
    return {
      matcap: false,
      controls: false,
      rayplay: false,
      gui: false,
      cubeCam: false,
      composer: false,
      useBloom: false,
      ready: false,
      // layouts: {
      //   flower: false
      // },
      renderer: false,
      camera: false,
      scene: new Scene(),
      shaderCube: false
    }
  },
  methods: {
    // onClickItem (ev) {
    //   var gltfExporter = new GLTFExporter();
    //   var options = {
    //     binary: true,
    //   };
    //   var link = this.$refs.link
		// 	link.style.display = 'none';
		// 	document.body.appendChild( link ); // Firefox workaround, see #6594
		// 	function save ( blob, filename ) {
		// 		link.href = URL.createObjectURL( blob );
		// 		link.download = filename;
		// 		link.click();
		// 		// URL.revokeObjectURL( url ); breaks Firefox...
    //   }
    //   function saveArrayBuffer( buffer, filename ) {
		// 		save( new Blob( [ buffer ], { type: 'application/octet-stream' } ), filename );
    //   }
    //   function saveString( text, filename ) {
		// 		save( new Blob( [ text ], { type: 'text/plain' } ), filename );
		// 	}

    //   gltfExporter.parse(ev.object, function ( result ) {
    //     if ( result instanceof ArrayBuffer ) {
    //       saveArrayBuffer(result, ev.object.name + '.glb');
    //     } else {
    //       var output = JSON.stringify(result, null, 2);
    //       console.log(output);
    //       saveString(output, ev.object.name + '.gltf');
    //     }
    //   }, options );
    //   // let v3 = new Vector3()
    //   // v3.setFromMatrixPosition(ev.object.matrixWorld)
    //   // let place = v3.clone()
    //   // place.y = 0
    //   // this.$refs.game.game.charmover.position.copy(place)
    //   // console.log()
    // },
    setupInteraction () {
      this.rayplay = new RayPlay({ onResize: this.onResize, mounter: this.ctx.touchdiv, camera: this.ctx.camera, onLoop: this.onLoop, onClean: this.onClean })
      this.controls = new CityControls({ camera: this.ctx.camera, touchdiv: this.ctx.touchdiv, onLoop: this.onLoop, onClean: this.onClean })
    },
    setup () {
      this.camera = new PCamera({ element: this.renderRootElement, onResize: this.onResize })
      this.scene.add(this.o3d)
    },
    setupGUI () {
      if (process.env.NODE_ENV === 'development' && window.innerWidth > 500) {
        const dat = require('dat.gui')
        const init = require('three-dat.gui')
        init(dat)
        const gui = new dat.GUI()
        this.gui = gui

        gui.addSimpleMaterial = (v) => {
          let ctrl = gui.addMaterial(v.name + getID(), v)
          this.onClean(() => {
            gui.remove(ctrl)
          })
          ctrl.open()
          return ctrl
        }

        // gui.domElement.style.position = 'absolute'
        // gui.domElement.style.top = '0px'
        // gui.domElement.style.right = '0px'
        // this.element.appendChild(gui.domElement)

        // this.addEventListener('reset-cam', () => {
        //   gui.updateDisplay()
        // })

        this.onClean(() => {
          gui.destroy()
        })
      }
    },
    setupBloom () {
      if (!this.useBloom) {
        return
      }

      // this.composer = new CityBloom({
      //   renderer: this.ctx.renderer,
      //   element: this.ctx.renderer.domElement,
      //   scene: this.ctx.scene,
      //   camera: this.ctx.camera,
      //   onLoop: this.onLoop,
      //   onResize: this.onResize,
      //   gui: this.gui
      // })

      // this.$on('syncBloom', () => {
      //   if (this.useBloom) {
      //     this.$emit('composer', this.composer)
      //   } else {
      //     this.$emit('composer', false)
      //   }
      // })

      // this.$watch('useBloom', () => {
      //   this.$emit('syncBloom')
      // })
      // this.$emit('syncBloom')

      /* BLOOM END */
    },
    async setupComputeResources () {
      // this.chromatics = new ShaderCubeChromatics({
      //   res: 32,
      //   renderer: this.ctx.renderer,
      //   loop: this.onLoop,
      //   color: new Color('#ffffff')
      // })

      // this.cubeCam = new CubeCam({
      //   res: 64,
      //   renderer: this.ctx.renderer,
      //   scene: this.ctx.scene,
      //   camera: this.ctx.camera,
      //   loop: this.onLoop,
      //   clean: this.onClean
      // })
      this.matcap = {}

      let [
        silver
      ] = await Promise.all([
        loadTexture(require('../GLContent/Beauty/matcap/silver.png'))
          .then((tex) => {
            return new MeshMatcapMaterial({ matcap: tex })
          })
      ])
      this.matcap.silver = silver

      this.ready = true
    }
  },
  mounted () {
    // this.setupLabel2D()

    this.setup()
    // this.setupGUI()
    this.setupComputeResources()
    this.setupInteraction()
    // this.setupBloom()
    // this.scene.background = new TextureLoader().load(require('./img/stained-glass.jpg'))

    // this.renderRootElement.style.backgroundImage = `url('${require('./img/stained-glass.jpg')}')`
    // // this.renderRootElement.style.backgroundImage = `url('${require('./img/skyspace.jpg')}')`
    // this.renderRootElement.style.backgroundSize = `cover`
    // this.renderRootElement.style.backgroundColor = `black`
    // this.renderRootElement.style.backgroundPosition = `center center`
    // this.renderRootElement.style.backgroundRepeat = `no-repeat no-repeat`
  },
  beforeDestroy () {
    // this.renderRootElement.style.backgroundSize = ``
    // this.renderRootElement.style.backgroundImage = ``
    // this.renderRootElement.style.backgroundColor = ``
    // this.renderRootElement.style.backgroundPosition = ``
    // this.renderRootElement.style.backgroundRepeat = ``
  }
}
</script>

<style>
</style>
